import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconFormOctagon"><Path d="M15.417 2C15.8811 2 16.3261 2.18459 16.6543 2.5127L21.4873 7.3457C21.8154 7.67388 22 8.11894 22 8.58301V15.417C22 15.8811 21.8154 16.3261 21.4873 16.6543L16.6543 21.4873C16.3261 21.8154 15.8811 22 15.417 22H8.58301C8.11894 22 7.67388 21.8154 7.3457 21.4873L2.5127 16.6543C2.18459 16.3261 2 15.8811 2 15.417V8.58301C2 8.11894 2.18459 7.67388 2.5127 7.3457L7.3457 2.5127C7.67388 2.18459 8.11894 2 8.58301 2H15.417Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagon;
